/* eslint-disable import/prefer-default-export */
const slotsHasList = (flagName, listName) => (slots, templates) => {
  if (!slots) {
    return slots;
  }

  return slots.map(
    (slot) => {
      slot[flagName] = !!(templates[slot.templateId]?.[listName]?.length);
      return slot;
    }
  );
};
const slotsHasMenus = slotsHasList('hasMenus', 'menu_ids');
const slotsHasAddOns = slotsHasList('hasAddOns', 'item_ids');

// normalizes the slots to the service types and puts them in 'available' array of matching
function getAvailableByServiceTypes(serviceTypes, slots) {
  const serviceTypesList = [...serviceTypes];

  slots.forEach((slot) => {
    let found = false;

    if (typeof slot.serviceTypeId !== 'number') {
      slot.serviceTypeId = -1;
    }

    serviceTypesList.forEach((service) => {
      if (slot.serviceTypeId === service.serviceTypeId) {
        slot.serviceTypeName = service.serviceTypeName;
        slot.serviceTypeKey = service.serviceTypeKey;
        service.available.push(slot);
        found = true;
      }
    });

    if (found === false) {
      serviceTypesList[0].available.push(slot);
    }
  });

  return serviceTypesList;
}

// returns an array of
// {
//  serviceTypeName: string,
//  serviceTypeKey: string,
//  serviceTypeId: number,
//  available: array of slot objects,
// }
//
const venueExceptions = {
  NOBLE_EXPERIMENT: 569,
  ROBERT_SINSKEY_VINEYARDS: 885,
  THE_MULWRAY_UK: 2040,
};

function getServiceTypes(serviceTypes, venue, venueId) {
  // a default for a service type that is not an available service type for the venue
  const temp = [{ available: [] }];

  serviceTypes.forEach((service) => {
    if ('availableServiceTypes' in venue.venue
      && venue.venue.availableServiceTypes.includes(service.id.toString())
    ) {
      temp.push({
        serviceTypeName: service.value,
        serviceTypeKey: service.key,
        serviceTypeId: service.id,
        available: [],
      });
    }

    // EXCEPTIONS - lol
    // Noble Experiment doesn't serve dinner.
    if (venueId === venueExceptions.NOBLE_EXPERIMENT && service.value === 'dinner') {
      temp[temp.length - 1].serviceTypeName = 'Cocktails';
    }
  });

  // Robert Sinskey Vineyards doesn't serve food either (885)
  // and one more time because europe The Mulwray UK (2040)
  if (venueId === venueExceptions.ROBERT_SINSKEY_VINEYARDS
    || venueId === venueExceptions.THE_MULWRAY_UK) {
    temp.forEach((item) => {
      item.serviceTypeName = '';
    });
  }

  return temp;
}

const processVenueReservations = (venueReservationData, serviceTypes, venueId) => {
  const result = {
    activeNotifications: [],
    notifyForUnavailable: [],
    partnershipBranding: null,
    reservations: [],
    templates: {},
    platinumNight: null,
  };
  if (!venueReservationData.results?.venues?.length) {
    return result;
  }
  const [venue] = venueReservationData.results.venues;
  result.partnershipBranding = venue.venue?.source?.logo ? venue.venue.source : null;
  result.templates = venue.templates ? venue.templates : {};
  result.platinumNight = venueReservationData.results?.platinumNight;
  result.notifyForUnavailable = [];
  result.activeNotifications = {};
  const slots = slotsHasMenus(
    slotsHasAddOns(venue.slots, venue.templates),
    venue.templates
  );
  result.hasAddons = !!slots.find((slot) => slot.hasAddOns);
  result.analytics = {
    venueIsGda: venue.venue?.isGda,
    ccRequired: venue.venue?.allowCardBypass !== 1,
    location: venue.venue?.location,
  };
  const reservationsTemp = getAvailableByServiceTypes(
    getServiceTypes(serviceTypes, venue, venueId),
    venue.slots || []
  );

  if ('availableServiceTypes' in venue.venue) {
    reservationsTemp.forEach((rt) => {
      if ('serviceTypeId' in rt && rt.available.length === 0 && venue.venue.availableServiceTypes.includes(rt.serviceTypeId.toString())) {
        result.notifyForUnavailable.push({ id: rt.serviceTypeId, name: rt.serviceTypeName });
      }
    });
  }

  if ('notifies' in venue) {
    venue.notifies.forEach((notify) => {
      result.activeNotifications[notify.serviceTypeId] = { ...notify, id: notify.serviceTypeId };
    });
  }
  result.reservations = reservationsTemp;
  return result;
};

export {
  getAvailableByServiceTypes,
  getServiceTypes,
  slotsHasAddOns,
  slotsHasMenus,
  processVenueReservations,
};
